import { Injectable } from '@angular/core';
import {NotificationState} from '../state/notification.state';
import {NotificationApi} from '../api/notification.api';
import {Observable} from 'rxjs';
import {Notification} from '../models/notification.model';
import {ToastrWrapperService} from '../../../services/toastr-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationFacade {

  constructor(private notificationState: NotificationState,
              private notificationApi: NotificationApi,
              private toastr: ToastrWrapperService) { }

  loadNotifications(workspaceId: string): void {
    this.notificationApi.getNotification(workspaceId).subscribe(
      (res) => {
        this.notificationState.updateNotifications(res.data.notifications);
        this.notificationState.updateUnSeenCount(res.data.totalUnSeenCount);
      },
    );
  }


  getNotifications$(): Observable<Notification[]> {
    return this.notificationState.getNotifications$();
  }

  getUnSeenCount$(): Observable<number> {
    return this.notificationState.getUnSeenCount$();
  }

  deleteNotification(workspaceId: string, notificationId: string): void {
    this.notificationApi.deleteNotification(workspaceId, notificationId).subscribe(
        () => {
          this.notificationState.filterNotifications(notificationId);
        },
        () => {
          this.toastr.showError('عملیات ناموفق بود');
        });
  }

  updateSeenNotifications(workspaceId: string, notificationIds: any[]) {
    this.notificationApi.updateSeenNotifications(workspaceId,notificationIds).subscribe(
      () => {
        this.notificationState.updateSeenNotifications();
      },
      () => {
          this.toastr.showError('خطا در بروزسانی اعلان های مشاهده شده');
      },
    );
  }
}
